module.exports = __webpack_public_path__ + "img/department_contract_management.5e97f16e.png";